import { Grid, Typography } from "@mui/material";
import { CoreContext } from "context/CoreContext";
import { useContext, useState } from "react";
import { CustomCheckbox } from "./styled";

export default function CreatorGalleryCard({
  influencer,
  clickable,
  selected,
  canBeSelected = true,
  onClick,
  reload,
  creators,
  campaign,
}) {
  const [hover, setHover] = useState(false);
  const { setModal } = useContext(CoreContext);
  const cardStyle = {
    padding: "24px",
    borderRadius: "16px",
    border: `1px solid ${(selected || hover) && canBeSelected
        ? "rgba(175, 0, 227, 1)"
        : "rgba(204, 196, 216, 1)"
      }`,
    marginTop: "16px",
    width: "100%",

    background: "rgba(255, 255, 255, 1)",
    boxShadow: "0px 0px 16px 0px rgba(0, 0, 0, 0.16)",
    cursor: clickable ? "pointer" : "default",
  };

  return (
    <Grid
      container
      sx={cardStyle}
      size={12}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={clickable ? onClick : undefined}
    >
      {/* Informações do Influenciador */}
      <Grid
        item
        size={10}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6" sx={{ fontSize: "24px", fontWeight: 700 }}>
          {influencer.name}
        </Typography>

        <Typography variant="body1" sx={{ fontSize: "16px" }}>
          @{influencer.profile}
        </Typography>

        {canBeSelected && (
          <Grid
            item
            sx={{ display: "flex", alignItems: "center", marginTop: "8px" }}
          >
            <CustomCheckbox
              type="checkbox"
              checked={selected}
              onClick={clickable ? onClick : undefined}
              onChange={clickable ? onClick : undefined}
            />
            <Typography variant="body2" sx={{ fontSize: "16px" }}>
              Selecionar Creator
            </Typography>
          </Grid>
        )}
      </Grid>

      {/* Imagem do Influenciador */}
      <Grid
        item
        size={2}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "top",
        }}
      >
        <img
          src={influencer.imageUrl || "/icons/menu4-off.svg"}
          alt="Influencer"
          width="64"
          height="64"
          style={{ borderRadius: "50%" }}
        />
      </Grid>
      {/* defesa do Influenciador */}
      <Grid
        item
        size={12}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "top",
        }}
        onClick={() =>
          setModal({
            type: "detail-creator",
            item: { influencer },
          })
        }
      >
        <Typography
          variant="h6"
          sx={{ fontSize: "20px", fontWeight: 700, paddingTop: "16px" }}
        >
          Defesa
        </Typography>
        <Typography
          variant="h7"
          sx={{
            fontSize: "16px",
            lineHeight: "20px",
            height: "40px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2,
          }}
        >
          {influencer.defense}
        </Typography>
      </Grid>

      {/* Redes Sociais */}
      <Grid
        item
        size={12}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "32px",
        }}
      >
        <Grid item sx={{ display: "flex", gap: "8px", alignItems: "flex-end" }}>
          {influencer.socialNetworks.instagram && (
            <img
              src="/icons/insta-grey.svg"
              width="32"
              height="32"
              alt="Instagram"
              onClick={() =>
                window.open(influencer.socialNetworks.instagram.link)
              }
              style={{ cursor: "pointer" }}
            />
          )}

          {influencer.socialNetworks.tiktok && (
            <img
              src="/icons/tiktok-grey.svg"
              width="32"
              height="32"
              alt="TikTok"
              onClick={() => window.open(influencer.socialNetworks.tiktok.link)}
              style={{ cursor: "pointer" }}
            />
          )}

          {influencer.socialNetworks.youtube && (
            <img
              src="/icons/galery.svg"
              width="32"
              height="32"
              alt="YouTube"
              onClick={() =>
                window.open(influencer.socialNetworks.youtube.link)
              }
              style={{ cursor: "pointer" }}
            />
          )}
        </Grid>

        {/* Seguidores e Views */}
        <Grid
          item
          sx={{ display: "flex", gap: "24px", alignItems: "flex-end" }}
        >
          <Statistic
            icon="/images/heart.png"
            label="Seguidores"
            value={numberToK(influencer.totalFollowers)}
          />
          {!influencer.totalViews ? (
            ""
          ) : (
            <Statistic
              icon="/images/button-play.png"
              label="Views"
              value={numberToK(influencer.totalViews ?? 0)}
            />
          )}
          {campaign?.status !== "finished" && <div
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "32px",
              background: "rgba(244, 244, 244, 1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
            }}
            onClick={() =>
              setModal({
                type: "delete-creator",
                item: { influencer, creators, campaign },
                reload,
              })
            }
          >
            <img
              src="/icons/creator-trash.svg"
              width={"22px"}
              height={"22px"}
            />
          </div>}
        </Grid>
      </Grid>
    </Grid>
  );
}

// Componente separado para estatísticas
function Statistic({ icon, label, value }) {
  return (
    <Grid
      item
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Grid item sx={{ display: "flex", alignItems: "center" }}>
        <img
          src={icon}
          width="17"
          height="16"
          alt={label}
          style={{ marginRight: "4px" }}
        />
        <Typography variant="body2">{label}</Typography>
      </Grid>
      <Typography
        sx={{
          fontSize: "32px",
          fontWeight: 700,
          margin: 0,
          background:
            "linear-gradient(90.02deg, #AF00E3 11.75%, #FF00D6 80.59%, #FF00D6 81.46%)",
          WebkitTextFillColor: "transparent",
          WebkitBackgroundClip: "text",
        }}
      >
        {value}
      </Typography>
    </Grid>
  );
}

// Função para formatar números
function numberToK(number) {
  return number >= 1e6
    ? `${Math.floor(number / 1e6)}M`
    : number >= 1e3
      ? `${Math.floor(number / 1e3)}K`
      : number;
}
